// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var DialogJs = require("./Dialog.js").default;

var make = DialogJs;

exports.make = make;
/* make Not a pure module */
